import { IconButton } from '@/lib';
import { TrashIcon } from '@/lib/Icons';
import { WorkspaceUserWithRole } from '@/models/workspace';
import { ColumnDef } from '@tanstack/react-table';
import { FC } from 'react';

type UserActionsCellProps = {
  user: WorkspaceUserWithRole;
  canDelete?: boolean;
  onDeleteClick?: (user: WorkspaceUserWithRole) => void;
};

const UserActionsCell: FC<UserActionsCellProps> = ({ user, canDelete, onDeleteClick }) => {
  if (!canDelete || !onDeleteClick) {
    return null;
  }

  return (
    <div className='flex justify-end'>
      <IconButton
        onClick={(e) => {
          e.stopPropagation();
          onDeleteClick(user);
        }}
        intent='link-grey'
        size='sm'
        leadingIcon={<TrashIcon className='size-4' />}
      />
    </div>
  );
};

export const createUserActionsColumn = (canDelete: boolean, onDeleteClick: (user: WorkspaceUserWithRole) => void): ColumnDef<WorkspaceUserWithRole> => ({
  id: 'actions',
  header: '',
  cell: ({ row }) => <UserActionsCell user={row.original} canDelete={canDelete} onDeleteClick={onDeleteClick} />,
  enableSorting: false,
  size: 50,
});
